// extracted by mini-css-extract-plugin
export default {"vl":"Experience_vl__MMQaT","companyName":"Experience_companyName__l+xDh"};